export default [{
    path: "*",
    name: "首页",
    component: resolve => require(["@/pages/index"], resolve)
  },
  // 首页
  {
    path: "/index",
    name: "index",
    component: resolve => require(["@/pages/index"], resolve)
  },
  // 列表页
  {
    path: "/list",
    name: "list",
    component: resolve => require(["@/pages/list"], resolve)
  },
  // 详情页
  {
    path: "/detail",
    name: "detail",
    component: resolve => require(["@/pages/detail"], resolve)
  },
  // 加群页
  {
    path: "/group",
    name: "group",
    component: resolve => require(["@/pages/group"], resolve)
  },
  // 视频页
  {
    path: "/video",
    name: "h5video",
    component: resolve => require(["@/pages/video"], resolve)
  },
];